import styled from 'styled-components';
import { media } from '../../../utilities/media';
export const Wysiwyg = styled.div `
  color: ${({ inverted, theme }) => inverted ? theme.palette.white.main : theme.palette.midnight.main};
  font-size: ${({ theme }) => theme.typography.font.sizes.normal}px;
  line-height: 1.31;

  h1 {
    font-size: 34px;
    line-height: 1.18;
  }

  h2 {
    font-size: ${({ theme }) => theme.typography.font.sizes.medium}px;
    line-height: 1.14;
  }

  ul > li {
    position: relative;
    padding-left: ${({ tickmark }) => (tickmark ? '32px' : '24px')};

    & + li {
      margin-top: 3px;
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      top: 7px;
      width: 8px;
      height: 8px;
      background: ${({ theme }) => theme.palette.cyan.main};
      border-radius: 50%;

      ${({ tickmark }) => tickmark
    ? `
              top: 0px !important;
              width: 24px;
              height: 24px;
              background: url(${window._ASSETS.CheckImg});
              background-size: cover;
              border-radius: none;
          `
    : ''}
    }
  }

  ol {
    counter-reset: listCounter;

    > li {
      counter-increment: listCounter;
      position: relative;
      padding-left: 24px;

      & + li {
        margin-top: 3px;
      }

      &:before {
        content: counter(listCounter);
        position: absolute;
        top: 0;
        left: 0;
        color: ${({ theme }) => theme.palette.cyan.main};
        line-height: 1.31;
      }
    }
  }

  a {
    color: ${({ theme }) => theme.palette.cyan.main};
  }

  > * + *,
  * + p,
  * + ul,
  * + ol {
    margin-top: 10px;
  }

  > * + h1,
  > * + h2 {
    margin-top: 24px;
  }

  ${media.tablet `
    line-height: 1.5;

    h1 {
      font-size: ${({ theme }) => theme.typography.font.sizes.bigger}px;
      line-height: 1.16;
    }

    h2 {
      font-size: ${({ theme }) => theme.typography.font.sizes.big}px;
      line-height: 1.25;
    }

    ul > li {
      &:before {
        top: 9px;
      }

      & + li {
        margin-top: 1px;
      }
    }

    ol > li {
      &:before {
        line-height: 1.5;
      }

      & + li {
        margin-top: 1px;
      }
    }

    > * + *,
    * + p,
    * + ul,
    * + ol {
      margin-top: 8px;
    }

    > * + h1,
    > * + h2 {
      margin-top: 16px;
    }
  `}
`;
//# sourceMappingURL=index.js.map